import React from "react";
import { Routes, Route, Navigate, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";
import { getAdminProfile } from "api/adapters/auth/auth";
import { setAdminProfile } from "store/slices/authSlice";
import { getToken } from "utils/cookies.helpers";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const adminProfile = useSelector((state) => state.auth.adminProfile);
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Dashboard");

  // Fetch profile via useQuery if token exists but profile not in Redux
  useQuery({
    queryKey: ["adminProfile"],
    queryFn: getAdminProfile,
    enabled: !!getToken() && !adminProfile,
    onSuccess: (res) =>
      dispatch(setAdminProfile(res.data)),
  });

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    let activeRoute = "Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Horizon UI Tailwind React"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="px-2 pt-8 pb-2">
              {/* <p className="text-sm font-normal text-gray-600 dark:text-gray-400">
                <Link to="/admin/dashboard" className="hover:underline">Home</Link>
                {" / "}
                <span className="capitalize text-orange-500 dark:text-orange-400">{currentRoute}</span>
              </p> */}
              <div className="mt-1 flex items-center gap-3">
                <div className="h-7 w-1.5 rounded-full bg-gradient-to-b from-orange-500 to-orange-300" />
                <h1 className="text-2xl font-bold capitalize text-navy-700 dark:text-white">
                  {currentRoute}
                </h1>
              </div>
            </div>
            <div className="mx-auto mb-auto h-full min-h-[84vh] px-2 pb-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}

                <Route
                  path="/"
                  element={<Navigate to="/admin/dashboard" replace />}
                />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
